import { ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon } from '@material-ui/icons';
import { Box, Card, Typography, IconButton, CircularProgress } from '@material-ui/core';

/**
 * @function ResultPanel
 * @description One foldable card in the left column: a heading, a spinner while the run is still
 * going, and a body that folds away under the chevron.
 * The two tables on this screen are a card each rather than two halves of one. Held together,
 * only the inner table could scroll - the heading of the second was pushed below the fold and the
 * card carried a scrollbar of its own inside the column's. Apart, each folds on its own and the
 * column is the only thing that scrolls.
 * @param {Object} props
 * @param {String} props.title - The heading.
 * @param {Boolean} props.collapsed - Whether the body is folded away.
 * @param {Function} props.onToggle - Called when the chevron is clicked.
 * @param {Boolean} [props.busy] - Shows the spinner beside the heading.
 * @param {Object} props.classes - The page's styles, resolved below the module's theme provider.
 * @param {JSX.Element} props.children - The body.
 * **Called by:
 * @see {BathymetryResultContent}
 * @memberof module:Bathymetry
 * @returns {JSX.Element}
 */
const ResultPanel = ({ title, collapsed, onToggle, busy, classes, children }) => (
  <Card className={`${classes.cardMetrics} ${classes.metricsPadding}`}>
    <Box display="flex" alignItems="center" style={{ gap: 8, marginBottom: collapsed ? 0 : 6 }}>
      <Typography variant="subtitle2" style={{ fontWeight: 700, flexGrow: 1 }}>
        {title}
      </Typography>
      {busy && <CircularProgress size={14} thickness={5} style={{ color: '#42A5F5' }} />}
      <IconButton size="small" onClick={onToggle} aria-label={collapsed ? 'expand' : 'collapse'}>
        {collapsed ? <ExpandMoreIcon fontSize="small" /> : <ExpandLessIcon fontSize="small" />}
      </IconButton>
    </Box>
    {!collapsed && children}
  </Card>
);

export default ResultPanel;
